const applicantDetailsSummaryInitialState = {
    editData: false,
};

export default applicantDetailsSummaryInitialState;



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantDetailsSummary/applicantDetailsSummaryInitialState.js